import React from 'react';

import cx from 'classnames';

import Icon from 'components/shared/Icon';
import ArrowLeftIcon from 'components/shared/Icon/icons/ArrowLeftIcon';

import { IPaginationProps } from '../types';
import s from './index.module.css';

export const Pagination = ({ itemsPerPage, totalItems, currentPage, onPageChange }: IPaginationProps) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  function handlePageChange(page: number) {
    onPageChange(page);
  }

  const adjacentPages = 1;
  const startPage = Math.max(currentPage - adjacentPages, 0);
  const endPage = Math.min(currentPage + adjacentPages, totalPages - 1);

  return (
    <div className={s.pagination}>
      <button
        className={s.paginationButton}
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 0}
      >
        <Icon component={ArrowLeftIcon} className={s.arrowIcon} />
      </button>
      {Array.from({ length: totalPages }, (_, index) => {
        if (index === startPage) {
          return (
            <button
              key={index}
              className={cx(s.paginationButton, index === currentPage && s.activeButton)}
              onClick={() => handlePageChange(index)}
            >
              {index + 1}
            </button>
          );
        } else if (index > startPage && index <= endPage) {
          return (
            <button
              key={index}
              className={cx(s.paginationButton, index === currentPage && s.activeButton)}
              onClick={() => handlePageChange(index)}
            >
              {index + 1}
            </button>
          );
        }
      })}
      <button
        className={s.paginationButton}
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages - 1}
      >
        <Icon component={ArrowLeftIcon} className={s.arrowIcon} rotate={180} />
      </button>
    </div>
  );
};
